import { create } from 'zustand';
import { loadingStore } from '@modules/core/adapter/outbound/stores/ui.store';
import { GetCategoryMenuUsecase } from '@modules/header/application/usecases/getCategoryMenu.usecase';
import { ICategoryMenu, IMainBottomMenuMobile, IMainMenuMobile } from '@modules/header/domain/models/menu.model';
import { CategoryMenuRepositoryImpl } from '../../inbound/repositories/categoryMenu.repository';
interface MenuState {
  mainMenuMobile: {
    topMenu: IMainMenuMobile[];
    bottomMenu: IMainBottomMenuMobile[];
    optionMenu: IMainBottomMenuMobile[];
  };
  categoryMenu: ICategoryMenu;
  fetchCategoryMenu: () => void;
}
const defaultCategoryMenu: ICategoryMenu = {
  foodType: {
    id: 'foodType',
    title: 'ประเภทอาหาร',
    menuList: null
  },
  cooking: {
    id: 'cooking',
    title: 'วิธีการปรุง',
    menuList: null
  },
  collection: {
    id: 'collection',
    title: 'คอลเลกชัน',
    menuList: null
  },
  group: {
    id: 'group',
    title: 'ไลฟ์สไตล์',
    menuList: null
  },
  meatCategory: {
    id: 'meatCategory',
    title: 'ประเภทเนื้อสัตว์',
    menuList: null
  }
};
export const menuStore = create<MenuState>(set => ({
  mainMenuMobile: {
    topMenu: [{
      title: 'กินอะไรดี?',
      iconImgUrl: '/icons/menu-mobile/fried.png',
      isHasSubMenu: true,
      redirectTo: null
    }, {
      title: 'คอลเลกชัน',
      iconImgUrl: '/icons/menu-mobile/recipe.png',
      isHasSubMenu: false,
      redirectTo: '/collection'
    }, {
      title: 'ผลิตภัณฑ์ซีพี',
      iconImgUrl: '/icons/menu-mobile/pork-mix-chicken.png',
      isHasSubMenu: false,
      redirectTo: '/product'
    }, {
      title: 'โปรโมชัน',
      iconImgUrl: '/icons/menu-mobile/calorie.png',
      isHasSubMenu: true,
      redirectTo: null
    }, {
      title: 'เคล็ดลับ',
      iconImgUrl: '/icons/menu-mobile/bake.png',
      isHasSubMenu: false,
      redirectTo: '/tips-tricks'
    }],
    bottomMenu: [{
      title: 'ฟู้ดเซอร์วิส',
      linkOut: '/food-service'
    }, {
      title: 'ซีพี คอนเนค',
      linkOut: '/cp-connect'
    }, {
      title: 'ติดต่อเรา',
      linkOut: '/contact'
    },
    // hide ไว้ก่อน
    // {
    //     title: 'กินอย่างยั่งยืน',
    //     isLinkOut: true,
    //     linkOut: 'https://www.cpbrandsite.com/กินอย่างยั่งยืน',
    // },
    {
      title: 'สมาชิกซีพีแบรนด์',
      isLinkOut: false,
      linkOut: process.env.CDP_DOMAIN
    }],
    optionMenu: [{
      title: 'แบบสอบถาม',
      isLinkOut: false,
      linkOut: `${process.env.CDP_DOMAIN}/survey`
    }, {
      title: 'รีวิวสินค้า',
      isLinkOut: false,
      linkOut: `${process.env.CDP_DOMAIN}/product`
    }]
  },
  categoryMenu: defaultCategoryMenu,
  fetchCategoryMenu: async () => {
    try {
      loadingStore.setState({
        isLoading: true
      });
      const categoryMenuRepositoryImpl = new CategoryMenuRepositoryImpl();
      const getCategoryMenuUsecase = new GetCategoryMenuUsecase(categoryMenuRepositoryImpl);
      const categoryMenu = await getCategoryMenuUsecase.handle();
      set(() => ({
        categoryMenu: {
          foodType: {
            ...defaultCategoryMenu.foodType,
            menuList: categoryMenu.foodType
          },
          cooking: {
            ...defaultCategoryMenu.cooking,
            menuList: categoryMenu.cooking
          },
          collection: {
            ...defaultCategoryMenu.collection,
            menuList: categoryMenu.collection
          },
          group: {
            ...defaultCategoryMenu.group,
            menuList: categoryMenu.group
          },
          meatCategory: {
            ...defaultCategoryMenu.meatCategory,
            menuList: categoryMenu.meatCategory
          }
        }
      }));
    } catch (error) {
      console.error('error fetchCategoryMenu', error);
    } finally {
      loadingStore.setState({
        isLoading: false
      });
    }
  }
}));